import { IS_LOADING } from '../../action-types/ui/preview';

export const STATE_KEY = 'isLoading';

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case IS_LOADING: {
      const { flag } = action;
      return flag;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/preview.js